import { render, staticRenderFns } from "./RelatorioVencimentoDocumentos.vue?vue&type=template&id=86c62682&"
import script from "./RelatorioVencimentoDocumentos.vue?vue&type=script&lang=js&"
export * from "./RelatorioVencimentoDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VToolbar})
